import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { VolumeSet } from "../../schema/types/volumeSet/entity";

export const volumeSetApi = createApi({
  reducerPath: "volumeSetApi",
  baseQuery: customBaseQuery,
  tagTypes: ["VolumeSet"],
  endpoints: (builder) => ({
    getVolumeSet: builder.query<VolumeSet, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({
            url: link,
          });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => {
        return [{ type: "VolumeSet", id: link }];
      },
    }),
  }),
});

export const { useGetVolumeSetQuery } = volumeSetApi;
